import { useEffect, useState } from 'react';
import axios from 'axios';
import { camelizeKeys } from 'humps';
import endpoints from '../define/endpoints';

export function useOptionals(optionalsIds) {
  const [optionals, setOptionals] = useState([]);
  useEffect(() => {
    (async function () {
      if (optionalsIds) {
        const { data } = await axios.get(`${endpoints.core}/optionals`, {
          params: {
            id: optionalsIds,
            locale: window.freedomeConfig.locale
          },
        });
        setOptionals(camelizeKeys(data));
      }
    })();
  }, [optionalsIds]);
  return optionals;
}
